
<h1 mat-dialog-title>About this website/h1>
<div mat-dialog-content>
    <p>
        Welcome to the demo! Use the blue "About this website" button on the right-hand side to display instructions on how to setup your authenticator and Woodgrove.ms account.
    </p>
    <p> 
        Press the OK button and this dialog will not bother you again :)
    </p>
</div>
<div mat-dialog-actions> 
    <button mat-button mat-dialog-close>OK</button>
</div>